
// A $( document ).ready() block.
$( document ).ready(function() {
    $('.button-click').click(function(){
      $(this).parents().find('.popup-newsletter-cs').addClass('active');
      $('.site-header-sticky .site-header').addClass('remove-fixed');
    });
    $('.click-close').click(function(){
      $(this).parents().find('.popup-newsletter-cs').removeClass('active');
      $('.site-header-sticky .site-header').removeClass('remove-fixed');
    });
  
});

$(document).on("click",".list-social__link.chat-jivo",function(event) {
  event.preventDefault();
      let params = {start: 'chat'};
    let apiResult = jivo_api.open(params);
    
    if (apiResult.result === 'fail') {
        console.log('Widget failed to open');
    } else {
        console.log('Widget open successfully');
    }

});
$(document).ready(function () {
 const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const product = urlParams.get('title');
  const price = urlParams.get('price');
  const pricefake = price.replace('$','');
  const  url = new URL(document.URL);
  const urlsp = url.searchParams;

  const producturl = 'https://www.maafushidive.com'+ urlParams.get('url');

  const quantity = urlParams.get('quantity');
  const Totals = '$' + Number(pricefake) * Number(quantity) ;
    setTimeout(
    function() {
      $('#10007-text-2').val(product);
      $('#10007-text-3').val(price);
      $('#10007-text-4').val(Totals);
      $('#10007-text-5').val(quantity);
      $('#10007-url-1').val(producturl);
    }, 1000);
});
document.addEventListener("DOMContentLoaded", function(event) { 
  var nameId = $('main').attr("data-template-name");
  if (nameId == 'isProduct') {
     checkPrice(); 
  }
});
$(document).ready(function () {
  $('#product-quantity-select').on('change', function (e) {
    checkPrice();
  });
  $('.variants-ui__input-select').on('change', function (e) {
    checkPrice();
  });
});
function checkPrice() {
    var hrefButton = $('#buttonReserve').attr('href');
    var isPriceElementSale = $('.price').hasClass('price--on-sale');
    var countQty = $('#product-quantity-select').find(":selected").val();
    var priceItem = $('.price .price__current .money').html().trim();
    var newHrefButton = '';
    if(hrefButton.indexOf('&quantity') != -1){
          newHrefButton = hrefButton.substring(0, hrefButton.indexOf('&quantity')) + '&quantity=' + countQty + '&price=' + priceItem;
    } else {
          newHrefButton = hrefButton + '&quantity=' + countQty + '&price=' + priceItem;
    }
    $('#buttonReserve').attr('href',newHrefButton);
}